import { z } from 'zod';

/**
 * Schema for folder creation and updates
 */
export const folderSchema = z.object({
  name: z.string()
    .trim()
    .min(1, "Mappnamn måste anges")
    .max(255, "Mappnamn får vara max 255 tecken"),
  description: z.string()
    .max(2000, "Beskrivning får vara max 2000 tecken")
    .optional()
    .nullable(),
  project_id: z.string().uuid("Ogiltigt projekt-ID"),
  parent_folder_id: z.string().uuid("Ogiltigt mapp-ID").optional().nullable()
});

/**
 * Schema for folder share email validation
 */
export const folderShareEmailSchema = z.object({
  email: z.string()
    .email("Ogiltig e-postadress")
    .max(255, "E-postadress får vara max 255 tecken")
    .transform(email => email.trim().toLowerCase())
});

/**
 * Schema for folder updates
 */
export const folderUpdateSchema = z.object({
  name: z.string()
    .trim()
    .min(1, "Mappnamn måste anges")
    .max(255, "Mappnamn får vara max 255 tecken"),
  description: z.string()
    .max(2000, "Beskrivning får vara max 2000 tecken")
    .optional()
    .nullable()
});
